import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

/**
 * @example
 * <div data-controller="modal">
 *  <button data-action="click->modal#show">開く</button>
 *  <dialog data-modal-target="dialog">
 *   <button data-action="click->modal#close">閉じる</button>
 *  </dialog>
 * </div>
 */
export class ModalController extends Controller {
  static targets = ["dialog"];
  static values = {
    /** ページ表示時にモーダルを開いた状態にする */
    auto: Boolean,
  };

  connect() {
    // 読み込み時に自動で開く
    if (this.autoValue) {
      this.autoValue = undefined;
      this.show();
    }
    // backdropクリックで閉じる
    this.#dialog.addEventListener("click", this.#onClickBackdrop);
    // Escキーで閉じる
    this.#dialog.addEventListener("cancel", this.#cancel);
  }

  disconnect() {
    this.#dialog.close();
  }

  show() {
    this.#dialog.showModal();
    this.#dialog.setAttribute("tabindex", "-1");
    this.#dialog.focus();
    $(this.#dialog).fadeIn(300).addClass("is-open");
  }

  /** @deprecated */
  click() {}

  // Escキーで閉じる
  #cancel = (e) => {
    e?.preventDefault();
    this.close();
  };

  close() {
    const duration = 300;
    $(this.#dialog).fadeOut(duration).removeClass("is-open");
    setTimeout(() => {
      this.#dialog.close();
    }, duration);
  }

  get #dialog() {
    return this.hasDialogTarget ? this.dialogTarget : this.element;
  }

  #onClickBackdrop = (e) => {
    // <dialog>直下に何かdivがあるため、target==dialogだったらbackdropをクリックしたはず
    if (e.target === this.#dialog) this.close();
  };

  /** @deprecated */
  overlay() {}
}

/**
 * 離れた場所からmodalを開閉するボタン
 * @example
 * <button
 *   data-controller="modal-button"
 *   data-modal-button-modal-outlet="#modal"
 *   data-action="modal-button#show">開く</button>
 * <dialog id="modal" data-controller="modal">...</dialog>
 */
export class ModalButtonController extends Controller {
  static outlets = ["modal"];

  show() {
    for (const modal of this.modalOutlets) modal.show();
  }
  close() {
    for (const modal of this.modalOutlets) modal.close();
  }
}
